import React, { Component } from "react";
import styles from "./Popup.module.scss";
import { withRouter } from "react-router-dom";
import { Checkbox, Dropdown, DropdownDivider, DropdownHeader, DropdownItem, DropdownMenu } from "semantic-ui-react";
import Icon from "../UI/Icon/Icon";
import Button from "../UI/Button/Button";

var classNames = require("classnames");

class PagingGroupMultiSelectDropdown extends Component {
  constructor(props) {

    let pagingGroups = {}
    props.pagingGroups.forEach((group) => {
      pagingGroups[group.value] = false
    })

    super(props);
    this.state = {
      selectedPagingGroups: {...pagingGroups, ...props.selectedPagingGroups},
      pagingGroupOptions: null,
    };
  }

  handleOnChange = (group) => {
    const pagingGroups = this.state.selectedPagingGroups;
    pagingGroups[group] = !this.state.selectedPagingGroups[group]
    this.setState({ selectedPagingGroups: pagingGroups }, () => {
      this.props.handlePagingGroupSelect(this.state.selectedPagingGroups);
      this.loadPagingGroupOptions(); // keep checkboxes in sync with state
    })

  }

  handleSelectAll = (checkedCount, groupCount) => {
    const pagingGroups = this.state.selectedPagingGroups
    const valueToSet = checkedCount < groupCount
    Object.keys(pagingGroups).forEach(group => pagingGroups[group] = valueToSet)
    this.setState({ selectedPagingGroups: pagingGroups }, () => {
      this.props.handlePagingGroupSelect(this.state.selectedPagingGroups);
      this.loadPagingGroupOptions(); // keep checkboxes in sync with state
    })
  }

  loadPagingGroupOptions = () => {
    this.setState({
      pagingGroupOptions: this.props.pagingGroups.map((e) => {
        return (
          <DropdownItem key={e.value}
          onClick={(event) => {
            event.stopPropagation();
            this.handleOnChange(e.value);
          }}>
            <Checkbox
              checked={this.state.selectedPagingGroups[e.value]}
              name="pagingGroupList"
              key={e.value}
              id={e.value}
              value={e.key}
              label={e.key}
            />
          </DropdownItem>)
      })
    })
  }
  componentDidUpdate(prevProps, prevState) {
    if (prevProps.selectedAgency !== this.props.selectedAgency) {
      let pagingGroups = {}
      this.props.pagingGroups.forEach((group) => {
        pagingGroups[group.value] = false
      })
      this.setState({ selectedPagingGroups: pagingGroups }, () =>
        this.props.handlePagingGroupSelect(this.state.selectedPagingGroups))
    }
  }

  render() {
    const checkedCount = Object.values(this.state.selectedPagingGroups).filter(e => e).length
    const groupCount = Object.keys(this.state.selectedPagingGroups).length
    return (
      <Dropdown
        closeOnChange={false}
        onClick={this.loadPagingGroupOptions}
        className="pagingGroupMultiSelectDropdownClass"
        text={this.props.dropdownText}
        icon={<Icon icon="icon_arrowDownSmall" name="arrowIcon" />}
      >
        <DropdownMenu className="tileBg3 pagingSelect">
          <DropdownMenu scrolling>
            <DropdownItem className={styles.listItem}>
              <Checkbox
                checked={checkedCount === groupCount}
                onClick={(event) => {
                  event.stopPropagation();
                  this.handleSelectAll(checkedCount, groupCount);
                }}
                name="selectAll"
                key="selectAll"
                id="selectAll"
                value="selectAll"
                label="Select all"
              />
            </DropdownItem>
            {this.state.pagingGroupOptions}
          </DropdownMenu>
          <DropdownHeader>
            <div className={styles.listItem + " " + styles.bottomLabels + " " + "pagingSelectFooterContainer"}>
              <span className="selectedCountText">Selected: {checkedCount}</span>
              <Button content={'Clear selected'} disabled={checkedCount == 0} styles="clearButtonStyle" buttonClick={() => this.handleSelectAll(groupCount, groupCount)} />
            </div>
          </DropdownHeader>
        </DropdownMenu>

      </Dropdown>
    );
  }
}

export default withRouter(PagingGroupMultiSelectDropdown);
